// extracted by css-extract-rspack-plugin
export default {"cargoInfoContainer":"cargoInfoContainer-gBv7We","infoHeader":"infoHeader-KnbSNq","contentWrapper":"contentWrapper-xR4Rnv","nddInfoMap":"nddInfoMap-NbKloE"};